import { render, staticRenderFns } from "./DisagreeExistingPropertyDivisionOrder.vue?vue&type=template&id=7584132e"
import script from "./DisagreeExistingPropertyDivisionOrder.vue?vue&type=script&lang=ts"
export * from "./DisagreeExistingPropertyDivisionOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports